import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MobilePlanNew } from '@/features/planning/mobile/MobilePlanNew';

export const Route = createFileRoute('/_app/planning/new')({ component: PlanNewPage });

/** Form "Nuova attività" solo mobile; su desktop si torna alla pianificazione. */
function PlanNewPage() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobilePlanNew /> : <Navigate to="/planning" />;
}
